import { css } from "@emotion/react";
import MuiRadio from "@mui/material/Radio";

import { colors } from "@dotnet/telematics-design-system";

import DefaultCheckedIcon from "assets/customIcons/radio/DefaultCheckedIcon";
import DefaultIcon from "assets/customIcons/radio/DefaultIcon";
import DisabledCheckedIcon from "assets/customIcons/radio/DisabledCheckedIcon";
import DisabledIcon from "assets/customIcons/radio/DisabledIcon";
import ErrorCheckedIcon from "assets/customIcons/radio/ErrorCheckedIcon";
import ErrorIcon from "assets/customIcons/radio/ErrorIcon";

import { InfoComponent, LabelComponent } from "../components";
import { CombinedRadioProps } from "./types";

const Radio = ({ label, info, isError, ...props }: CombinedRadioProps) => {
    const { blue700, blue800, gray300, gray400 } = colors;

    const getIcons = () => {
        if (props.disabled) {
            return {
                icon: <DisabledIcon />,
                checkedIcon: <DisabledCheckedIcon />
            };
        } else if (isError) {
            return {
                icon: <ErrorIcon />,
                checkedIcon: <ErrorCheckedIcon />
            };
        } else {
            return {
                icon: <DefaultIcon />,
                checkedIcon: <DefaultCheckedIcon />
            };
        }
    };

    const icon = getIcons().icon;
    const checkedIcon = getIcons().checkedIcon;

    const isDefault = !props.disabled && !isError;

    return (
        <label
            css={css({
                display: "inline-flex",
                alignItems: "flex-start"
            })}
        >
            <MuiRadio
                {...props}
                size="small"
                icon={icon}
                checkedIcon={checkedIcon}
                sx={{
                    padding: "0",
                    marginRight: label || info ? "8px" : "0",
                    color: gray300,

                    "& > svg": {
                        fontSize: "24px"
                    },

                    "&:hover": {
                        color: isDefault ? gray400 : "unset"
                    },
                    "&.Mui-checked": {
                        color: blue700
                    },
                    "&:hover.Mui-checked": {
                        color: isDefault ? blue800 : "unset"
                    }
                }}
            />

            <div
                css={css({
                    cursor: props.disabled ? "auto" : "pointer",
                    alignSelf: "center",

                    "& > span": {
                        display: "block"
                    }
                })}
            >
                {label && (
                    <LabelComponent
                        title={label}
                        isDisabled={Boolean(props.disabled)}
                        hasInfo={Boolean(info)}
                    />
                )}

                {info && (
                    <InfoComponent
                        title={info}
                        isDisabled={Boolean(props.disabled)}
                    />
                )}
            </div>
        </label>
    );
};

export default Radio;
